export default __webpack_public_path__ + "static/media/group-8399.c1a50d99.png";